import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { TYPE, URL } from '../constant';
import { setVerbObject } from '../redux/logData';

import PROP from "../constant/PROP";
import useLocalStorage from "./useLocalStorage";

export default function useLearningBtn() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userData } = useLocalStorage();
  const { LEARNING, COURSE_LEARNING, TUTORIAL } = URL;
  
  useEffect(() => {
    const { pathname } = location;
    if (_.isEqual(pathname, URL.LEARNING.RESULT)) return;
    sessionStorage.setItem('lastPath', pathname);
  }, [location]);

  // 튜토리얼 페이지
  const goTutorial = (state, url, type) => {

    const params = {
      pathname: TUTORIAL,
      state: {
        ...state,
        nextUrl: url
      }
    }

    if (type === 'replace') {
      history.replace(params);
    } else {
      history.push(params);
    }
  }
  

  // 문제풀이
  const onLearningBtn = useCallback(({
    stage,
    type = "push",
    lrnEntyScnCd = null,
    learningEntryType = null,
    resumeYn = null,
  }) => {

    if (!stage) return;

    const state = {
      url: location.pathname,
      stgCd: stage,
      learningEntryType,
      lrnEntyScnCd: lrnEntyScnCd ? lrnEntyScnCd : TYPE.LEARNING.TOPIC,
      resumeYn : resumeYn
    }


    const xapiLog = {
      verbId: 'attempted',
      objectId: 'assessment',
      idName: 'stgCd',
      idValue: stage,
    }
    if (state.learningEntryType === 'OCR') xapiLog['contentInfo'] = { entryPoint: 'ep_001' }

    // console.log("########## xapiLog: ", JSON.stringify(xapiLog, null, 2));
    // 로그 data set
    dispatch(setVerbObject(xapiLog));
    
    if (! userData[ `isTutorial.${ PROP.ANSWERING_QUESTIONS_TUTORIAL_VERSION }` ]) {
      goTutorial(state, `${LEARNING.ANSWERING_QUESTIONS}/${state.lrnEntyScnCd}/${state.stgCd}`, type);
      return;
    }
    
    const params = {
      pathname: `${LEARNING.ANSWERING_QUESTIONS}/${state.lrnEntyScnCd}/${state.stgCd}`,
      state
    }
    
    if (type === 'replace') {
      history.replace(params);
    } else {
      history.push(params);
    }
  }, [location]);

  // AI문제풀이
  const onAiLearningBtn = useCallback((state) => {

    if (!state) return;

    // 로그 data set
    dispatch(setVerbObject({
      verbId: 'attempted',
      objectId: 'assessment',
      idName: 'stgCd',
      idValue: state.stgCd,
    }));

    if (! userData[ `isTutorial.${ PROP.ANSWERING_QUESTIONS_TUTORIAL_VERSION }` ]) {
      goTutorial(state, COURSE_LEARNING.AI_DIAGNOSIS_TEST.ANSWERING_QUESTIONS, "replace");
      return;
    }

    const params = {
      pathname: COURSE_LEARNING.AI_DIAGNOSIS_TEST.ANSWERING_QUESTIONS,
      state
    }
    history.replace(params);
    
  }, [location]);

  return [onLearningBtn, onAiLearningBtn];
}
